const VerticalDividerIcon = (props) => (
  <svg width='2' height='16' viewBox='0 0 2 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M1 0V16' stroke='#D9D9D9' />
  </svg>
);

export default VerticalDividerIcon;
